<div class="modal-header">
  <div class="header-title">
    <h4 class="m-0 title-modal">Cotação</h4>
    <div class="ml-3 chip">
      <p class="m-0 order-type">
        {{
          this.boobleModalData.orderType == 0
            ? "Receber de dinheiro"
            : "Envio de dinheiro"
        }}
      </p>
    </div>
  </div>
  <div (click)="closeBottomSheet()" class="close-icon tappable">
    <img src="assets/image/close-modal-icon.svg" />
  </div>
</div>

<div class="modal-body">
  <div class="">
    <div class="p-3 pv-5">
      <h4 class="mb-4">Dados da Ordem</h4>
      <div class="row mg-bottom-32">
        <div *ngIf="boobleModalData?.orderId" class="col-md-6">
          <span class="p-text-grey"
            >Número da ordem: &nbsp;
            <span class="value">{{ boobleModalData?.orderId }}</span></span
          ><br /><br />
        </div>

        <div *ngIf="boobleModalData?.orderId" class="col-md-6"></div>

        <div class="col-md-6">
          <span class="p-text-grey">
            {{
              this.boobleModalData?.orderType == 0
                ? "Quantia recebida:"
                : "Quantia enviada:"
            }}&nbsp;
            <span class="value"
              >{{ this.boobleModalData?.currency?.value }}
              {{ this.boobleModalData?.amount }}</span
            ></span
          ><br /><br />
          <span class="p-text-grey"
            >Natureza: &nbsp;
            <span class="value">{{
              this.boobleModalData?.finality?.description
            }}</span></span
          ><br /><br />

          <ng-container *ngIf="boobleModalData?.orderId">
            <span class="p-text-grey"
              >{{
                this.boobleModalData?.orderType == 0
                  ? "Nome do pagador"
                  : "Nome do recebedor"
              }}: &nbsp;
              <span class="value">{{
                this.boobleModalData?.orderType == 0
                  ? this.boobleModalData?.order.sender?.companyName
                  : this.boobleModalData?.order?.receiver?.name
              }}</span>
            </span>
            <br /><br />
          </ng-container>

          <span class="p-text-grey">
            {{
              this.boobleModalData?.orderType == 0
                ? "País remetente"
                : "País de destino"
            }}: &nbsp;
            <span class="value"
              >{{ this.boobleModalData?.country?.description }}
            </span>
          </span>
        </div>
      </div>
      <h4 class="mt-3">Detalhes da cotação</h4>

      <ng-container *ngIf="boobleModalData.orderId && !validHour">
        <div class="row">
          <div class="col">
            <div class="col-warning">
              <div class="d-flex justify-content-between margin-mb-16">
                <div class="d-flex gap-10">
                  <img src="assets/image/information-icon-blue.svg" />

                  <p class="text-p">
                    <strong class="weight-500"
                      >Fechamento do câmbio indisponível.</strong
                    >
                  </p>
                </div>
              </div>

              <p class="text-information">
                O fechamento do câmbio só é possível das 09:00 às 17:00 em dias
                úteis. O valor do câmbio comercial exibido corresponde à última
                consulta realizada e poderá sofrer atualizações quando o
                fechamento estiver disponível.
              </p>
            </div>
          </div>
        </div>
      </ng-container>

      <div class="glass mt-3">
        <div class="row">
          <ng-container>
            <div class="col-md-12">
              <div
                class="d-flex align-content-center justify-content-center mb-3"
              >
                <img
                  [src]="this.boobleModalData.currency.image"
                  alt=""
                  width="48px"
                  height="32px"
                  class="mr-2"
                />
                <h3 class="bandeira">
                  {{ this.boobleModalData.currency.description }}
                </h3>
              </div>
              <div class="row mt-2">
                <div
                  class="col-md-5 d-flex align-items-center justify-content-center"
                >
                  <p class="currency">
                    {{
                      this.boobleModalData.amount
                        | currency : this.boobleModalData.currency.value
                    }}
                  </p>
                </div>
                <div
                  class="col-md-2 d-flex align-items-center justify-content-center"
                >
                  <p class="currency currency-value">
                    <img src="assets/image/arrow-right-quotation.svg" />
                  </p>
                </div>
                <div
                  class="col-md-5 d-flex align-items-center justify-content-center"
                >
                  <ng-container *ngIf="!testing">
                    <p class="currency-value">
                      <span
                        *ngIf="!rate"
                        class="align-self-center spinner-border spinner-border-sm"
                      ></span>
                    </p>
                    <p *ngIf="rate" class="currency">
                      {{ calculated?.amountMN | brl }}
                    </p>
                  </ng-container>

                  <ng-container *ngIf="testing">
                    <p class="currency">
                      {{ this.boobleModalData.amount * 5.25792306 | brl }}
                    </p>
                  </ng-container>
                </div>
              </div>
            </div>
          </ng-container>

          <div
            class="col-md-12 d-flex justify-content-center align-content-center mt-3"
          >
            <p class="text-cambio">
              Taxa de câmbio: &nbsp;
              <ng-container *ngIf="testing">
                <small class="value text-cambio">
                  {{ 5.058686000000001?.toPrecision(5) }}
                </small>
              </ng-container>
              <ng-container *ngIf="!testing">
                <small class="value text-cambio">
                  {{ rate?.toPrecision(5) }}
                </small>
              </ng-container>
              <!-- <span class="text-last-date">23/05/2023 às 16:59</span> -->
            </p>
          </div>

          <div
            class="col-md-12 d-flex justify-content-center align-content-center mt-4"
          >
            <p class="text-fluxo">
              Fluxo de liquidação: &nbsp;<span class="value fluxo-value"
                >Hoje (D0 ➝ D0)</span
              >
            </p>
          </div>

          <!-- <div class="col-md-12 d-flex justify-content-center align-content-center mt-4">
              <span *ngIf="!rate" class="spinner-border spinner-border-sm"></span>
            </div> -->

          <div
            *ngIf="rate"
            (click)="showDetails = !showDetails"
            class="col-md-12 d-flex justify-content-center align-content-center mt-4"
          >
            <p class="text-button tappable more-details">Mais detalhes</p>

            <img *ngIf="!showDetails" src="assets/image/arrow-down.svg" />

            <img *ngIf="showDetails" src="assets/image/arrow-up.svg" />
          </div>

          <ng-container *ngIf="showDetails">
            <div
              class="col-md-12 d-flex justify-content-center align-content-center mt-4"
            >
              <p class="font-weight-500">
                Tarifa: &nbsp;<small class="value">{{
                  calculated?.tariff ?? 0 | brl
                }}</small>
              </p>
            </div>

            <ng-container *ngIf="isWarrenGlobal">
              <div
                class="col-md-12 d-flex justify-content-center align-content-center mt-4"
              >
                <p class="font-weight-500">
                  Spread: &nbsp;<small class="value"
                    >{{ calculated.spread * 100 | number : "1.2-2" }}%</small
                  >
                </p>
              </div>
            </ng-container>

            <div
              class="col-md-12 d-flex justify-content-center align-content-center mt-4"
            >
              <p>
                IOF ({{ taxIof * 100 | number : "1.2-2" }}%): &nbsp;
                <small class="value">{{
                  calculated?.totalIof || 0 | brl
                }}</small>
              </p>
            </div>

            <div
              class="col-md-12 d-flex justify-content-center align-content-center mt-4"
            >
              <p class="font-weight-500">
                Imposto de renda ({{ taxIr * 100 }}%): &nbsp;
                <small class="value">{{
                  calculated?.totalIr ?? 0 | brl
                }}</small>
              </p>
            </div>

            <div
              class="col-md-12 d-flex justify-content-center align-content-center mt-4"
            >
              <p class="font-weight-500">
                Valor efetivo total: &nbsp;<small class="value"
                  >{{
                    1
                      | currency
                        : this.boobleModalData?.order?.currency?.description
                  }}
                  = {{ calculated?.vet | brl }}</small
                >
              </p>
            </div>
          </ng-container>
        </div>
      </div>

      <div *ngIf="rate" class="d-flex justify-content-center gap-10 mg-top-16">
        <!-- <img src="assets/image/new-loading.svg" /> -->

        <p>
          <span
            class="align-self-center spinner-border spinner-border-sm"
          ></span>
        </p>

        <p class="">
          A taxa irá expirar em
          <span class="font-weight-500 p-blue">
            <countdown
              #cd
              [config]="{ leftTime: 30, format: 'ss' }"
            ></countdown>
            segundos
          </span>
        </p>
      </div>
    </div>
  </div>
</div>

<div class="buttons" *ngIf="!testing">
  <button
    (click)="confirmQuotation()"
    class="btn mb-3"
    [ngClass]="companyId ? 'btn-dark-primary-blue' : 'btn-dark-primary-blue-pf'"
    type="button"
    [disabled]="boobleModalData.orderId && !validHour"
  >
    <span *ngIf="boobleModalData.orderId">Aceitar e fechar o câmbio</span>
    <span *ngIf="!boobleModalData.orderId">Entrar em contato</span>
  </button>
</div>

<div class="buttons" *ngIf="testing">
  <button
    (click)="confirmQuotation()"
    class="btn mb-3"
    [ngClass]="companyId ? 'btn-dark-primary-blue' : 'btn-dark-primary-blue-pf'"
    type="button"
  >
    <span *ngIf="boobleModalData.orderId">Aceitar e fechar o câmbio</span>
    <span *ngIf="!boobleModalData.orderId">Entrar em contato</span>
  </button>
</div>
